var map = {
	"./Framabag.vue": 117,
	"./Framabee.vue": 115,
	"./Framabin.vue": 118,
	"./Framaboard.vue": 119,
	"./Framabookin.vue": 120,
	"./Framacalc.vue": 121,
	"./Framaclic.vue": 122,
	"./Framadrive.vue": 123,
	"./Framadrop.vue": 124,
	"./Framaestro.vue": 125,
	"./Framalink.vue": 126,
	"./Framanews.vue": 127,
	"./Framanotes.vue": 128,
	"./Framapack.vue": 129,
	"./Framapiaf.vue": 130,
	"./Framapic.vue": 131,
	"./Framasite.vue": 132,
	"./Framaslides.vue": 133,
	"./Framasphere.vue": 134,
	"./Framastory.vue": 135,
	"./Framavectoriel.vue": 136,
	"./Framawiki.vue": 137,
	"./Framemo.vue": 138,
	"./Framindmap.vue": 139,
	"./Framinetest.vue": 140,
	"./Home.vue": 116,
	"./Mumble.vue": 141,
	"./Myframa.vue": 142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;